export function hasPageOverlays(page) {
  if (page.overlays) {
    return page.overlays.length > 0;
  }
  return false;
}

export function getPageOverlay(page, index = 0) {
  return page.overlays[index];
}

export function isPageOverlayRequired(page) {
  if (hasPageOverlays(page)) {
    if (page.overlay_required) {
      if (page.overlay_required === true || page.overlay_required === 'true') {
        return true;
      }
    }
  }
  return false;
}
